/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrderQuery } from '../../models/get-order-query';
import { GetOrderQueryResult } from '../../models/get-order-query-result';

export interface ApiNurseryManagerOrdersGetOrderPost$Params {
      body?: GetOrderQuery
}

export function apiNurseryManagerOrdersGetOrderPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrdersGetOrderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrdersGetOrderPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrderQueryResult>;
    })
  );
}

apiNurseryManagerOrdersGetOrderPost.PATH = '/api/NurseryManager/Orders/GetOrder';
